import axios, { AxiosRequestConfig } from "axios";

import { ApiError } from "./error";

const generateUploadEndpoint = (
  apiEndpoint: string,
  caseId: string,
  type: string
) => `${apiEndpoint}/Upload?folderId=${caseId}&type=${type}`;

export async function postImages(
  apiEndpoint: string,
  caseId: string,
  type: string,
  images: Array<string>
): Promise<boolean> {
  const data = new FormData();
  images.forEach((image) => {
    data.append("file", image);
  });

  const config: AxiosRequestConfig = {
    method: "POST",
    url: generateUploadEndpoint(apiEndpoint, caseId, type),
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
    responseType: "json",
  };

  try {
    await axios(config);

    return true;
  } catch (error) {
    throw new ApiError(error.message);
  }
}
